import { render, staticRenderFns } from "./IosConfig.vue?vue&type=template&id=ed9388b0"
import script from "./IosConfig.vue?vue&type=script&lang=js"
export * from "./IosConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports